import AntMenu from 'antd/lib/menu';

import { HomeOutlined, InfoOutlined, MailOutlined, TeamOutlined, CompassOutlined } from '@ant-design/icons';

import { FormattedMessage } from 'react-intl';
import { useFela } from 'react-fela';
import { useHistory, useLocation } from 'react-router';

import config from 'config/index';

import rule from './Menu.rule';

const Items = {
    HOME: 'home',
    INFO: 'infoCategories',
    NEWS: 'news',
    MAPS: 'maps',
    PARTNERS: 'partners',
};

const Icons = {
    [Items.HOME]: HomeOutlined,
    [Items.INFO]: InfoOutlined,
    [Items.NEWS]: MailOutlined,
    [Items.MAPS]: CompassOutlined,
    [Items.PARTNERS]: TeamOutlined,
};

const ReverseLinks = {
    [config.routes[Items.HOME]]: Items.HOME,
    [config.routes[Items.INFO]]: Items.INFO,
    [config.routes[Items.NEWS]]: Items.NEWS,
    [config.routes[Items.MAPS]]: Items.MAPS,
    [config.routes[Items.PARTNERS]]: Items.PARTNERS,
};

const Menu = () => {
    const history = useHistory();
    const location = useLocation();
    const { css } = useFela();

    return (
        <div className={css(rule)}>
            <AntMenu
                mode="inline"
                defaultSelectedKeys={[ReverseLinks[location.pathname]].filter(Boolean)}
                onClick={({ key }) => {
                    const link = config.routes[key];
                    if (link) {
                        history.push(link);
                    }
                }}
            >
                {Object.values(Items).map(item => {
                    const Icon = Icons[item];

                    return (
                        <AntMenu.Item key={item}>
                            <Icon
                                style={{
                                    marginRight: 16,
                                }}
                            />
                            <FormattedMessage id={`menu.link.${item}`} />
                        </AntMenu.Item>
                    );
                })}
            </AntMenu>
        </div>
    );
};

export default Menu;
